var children =
/*#__PURE__*/
new Map();
var sessionIdIndex = 0;
var registry = {
  bookId: function bookId() {
    return "x:".concat(sessionIdIndex++);
  },
  register: function register(id, actor) {
    children.set(id, actor);
    return id;
  },
  get: function get(id) {
    return children.get(id);
  },
  free: function free(id) {
    children.delete(id);
  }
};
export { registry };